import { createSelector } from "reselect";
import { isEmpty } from "lodash";
//EXTRACT THE PART OF THE STATE
const getData = state => {
  const info = state.profile.info;
  const options = state.data.createdBy;
  if (isEmpty(info)) {
    return "-";
  }
  if (isEmpty(options)) {
    return "-";
  }

  const createdBy = options[info.createdBy];

  try {
    return createdBy.label;
  } catch (error) {
    return "-";
  }
};

const getMemberCreatedBy = createSelector(getData, createdBy => createdBy);
export default getMemberCreatedBy;



// WEBPACK FOOTER //
// ./src/_selectors/profileSelectors/getMemberCreatedBy.js